define(
    "diy/undo-redo/UiEntry",
    [
    ],
    /**
     *
     * @returns {module.undoRedo.UiEntry}
     */
    function () {
        'use strict';

        var UiEntry;

        /**
         * @class module.undoRedo.UiEntry
         * @template module.undoRedo.UiEntry
         * @lends {module.undoRedo.UiEntry.prototype}
         * @constructor
         */
        UiEntry = Klazz.extend({
            /** @type {String} */
            key: null,
            /** @type {String} */
            message: null,
            /** @type {String} */
            label: null,
            /** @type {Boolean} */
            executable: null,
            /** @type {String} */
            historyEntryType: null,
            /** @type {String} */
            type: 'undo',
            /** @type {Boolean} */
            sessionStart: false,

            /** @type {Function} */
            onSelect: function () {},
            /** @type {Function} */
            onDeselect: function () {},
            /** @type {Function} */
            onClick: function () {},

            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @param {module.undoRedo.Api} api
             * @param {String} type
             */
            initialize: function (entry, api, type) {
                this.key = entry.getKey();
                this.label = entry.getLabel();
                this.message = entry.getMessage();
                this.executable = entry.isExecutable();
                this.historyEntryType = entry.getManager();
                this.sessionIndex = entry.getSessionIndex();
                this.type = type;
                this.sessionStart = !!(entry.isSessionHead);

                var plugin = api.getPluginForEntryType(this.historyEntryType);

                if (plugin !== null) {
                    this.onSelect = function () {
                        plugin.onSelect(entry.getHistoryEntry());
                    };

                    this.onDeselect = function () {
                        plugin.onDeselect(entry.getHistoryEntry());
                    };
                } else {
                    this.onSelect = function () {};
                }

                if (this.isExecutable()) {
                    this.onClick = function () {
                        return api.executeEntryKey(this.key);
                    };
                } else {
                    this.onClick = function disabled() {
                        return Q(false);
                    };
                }
            },

            /**
             *
             * @returns {String}
             */
            getKey: function getKey() {
                return this.key;
            },
            /**
             *
             * @returns {String}
             */
            getMessage: function getMessage() {
                return this.message;
            },
            /**
             *
             * @returns {String}
             */
            getLabel: function getLabel() {
                return this.message;
            },
            /**
             *
             * @returns {Boolean}
             */
            isExecutable: function isExecutable() {
                return this.executable;
            }

        });

        return UiEntry;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/UiEntry.js
 ** module id = 912
 ** module chunks = 0
 **/